export default __webpack_public_path__ + "static/media/P945MANC1.3b8cd27b.pdf";